import FullScreenDialog, { FullScreenDialogCloseReason } from "../../components/full-screen-dialog/FullScreenDialog";
import { bindDialog, BindDialogReturn, DialogProps, DialogResult, DialogState, useDialogState } from "../../hooks/use-dialog-state/UseDialogState";
import { IEditDTO } from "../../services/alarm-scheme-data-service/Models";
import AlarmSchemeEditor from "./AlarmSchemeEditor";


import type { JSX } from "react";


export type AlarmSchemeEditorDialogInitValues = {
    groupID: number;
    organizationID: number;
    alarmSchemeID: number;
};

export type AlarmSchemeEditorDialogResultValues = {
    alarmScheme: IEditDTO | undefined;
};

export type AlarmSchemeEditorDialogResultReason = FullScreenDialogCloseReason | "cancel" | "save";

export type AlarmSchemeEditorDialogResult = DialogResult<AlarmSchemeEditorDialogResultValues, AlarmSchemeEditorDialogResultReason>;

export type AlarmSchemeEditorDialogProps = DialogProps<AlarmSchemeEditorDialogInitValues, AlarmSchemeEditorDialogResult>;

export default function AlarmSchemeEditorDialog({
    open,
    onClose,
    values
}: AlarmSchemeEditorDialogProps): JSX.Element {

    return (
        <FullScreenDialog open={open} onClose={reason => onClose({ reason: reason })}>
            <AlarmSchemeEditor
                groupID={values?.groupID as number}
                organizationID={values?.organizationID as number}
                alarmSchemeID={values?.alarmSchemeID}
                // onClose={({
                //     reason, 
                // }) => onClose({
                //     reason: reason,
                //     values: {
                //         alarmScheme: values
                //     }
                // })}

                onClose={({
                    reason, 
                    alarmScheme
                }) => onClose({
                    reason: reason,
                    values: {
                        alarmScheme: alarmScheme
                    }
                })}

            />
        </FullScreenDialog>
    );
}

export type AlarmSchemeEditorDialogState = DialogState<AlarmSchemeEditorDialogInitValues, AlarmSchemeEditorDialogResult>;
export type BindAlarmSchemeEditorDialogReturn = BindDialogReturn<AlarmSchemeEditorDialogInitValues, AlarmSchemeEditorDialogResult>;

export function useAlarmSchemeEditorDialogState(): AlarmSchemeEditorDialogState {
    return useDialogState();
}

export function bindAlarmSchemeEditorDialog(props: AlarmSchemeEditorDialogState): BindAlarmSchemeEditorDialogReturn {
    return bindDialog(props);
}
